import RouteEnum from "constants/RouteEnum";
import React from "react";
import { Col, Row } from "react-bootstrap";
import SezioneModel from "stores/contenuto/models/SezioneModel";
import BaseSubsection from "./BaseSubsection";

interface IProps {
    section: SezioneModel;
    showDivider: boolean;
    redirectToPage: (page: RouteEnum) => void;
}
interface IState {}

class BaseSection extends React.Component<IProps, IState> {
    private getWidth = (codiceTipoSezione: string, columnNumber: number) => {
        switch (codiceTipoSezione) {
            case "FUL":
                return 12;
            case "2CL":
                return 6;
            case "3CL":
                return 4;
            case "4CL":
                return 6;
            case "W37":
                switch (columnNumber) {
                    case 1:
                        return 4;
                    case 2:
                        return 8;
                }
                break;
            case "W73":
                switch (columnNumber) {
                    case 1:
                        return 8;
                    case 2:
                        return 4;
                }
                break;
        }
        return 12;
    };

    public render(): JSX.Element {
        const { section, showDivider, redirectToPage } = this.props;

        return (
            <>
                {section.titolo && section.titolo.trim().length > 0 ? (
                    <Row>
                        <Col
                            className="h4 font-weight-bold cq-text-blue text-center mb-3"
                            dangerouslySetInnerHTML={{ __html: section.titolo }}
                        ></Col>
                    </Row>
                ) : null}
                <Row>
                    {section.sottosezioni.map((subsection, keysubsection) => (
                        <Col
                            key={keysubsection}
                            md={this.getWidth(section.codiceTipoSezione, keysubsection + 1)}
                            className={section.codiceTipoSezione === "4CL" && keysubsection > 1 ? "mt-3" : ""}
                        >
                            <BaseSubsection subsection={subsection} redirectToPage={redirectToPage} />
                        </Col>
                    ))}
                </Row>
                {showDivider ? <hr className="w-100"></hr> : null}
            </>
        );
    }
}

export { BaseSection as Unconnected };
export default BaseSection;
